import { createContext } from 'react';

const theme = createContext({
   color: '',
   onChange: () => { }
});


export default theme;